import type React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { getEntityStatusPaletteColor } from "./OrderStatusChip";

const DEFAULT_MARKS = [0, 20, 100] as const;

interface StatusProgressBarProps {
  progress: number;
  marks?: readonly number[];
  /** When set, the bar fill uses this status's chip color. */
  status?: string;
}

const StatusProgressBar: React.FC<StatusProgressBarProps> = ({
  progress,
  marks = DEFAULT_MARKS,
  status,
}) => {
  const theme = useTheme();
  const fillColor = status
    ? getEntityStatusPaletteColor(status, theme)
    : theme.palette.success.main;

  return (
    <Box sx={{ mt: 1.25, maxWidth: 360 }}>
      <Box
        sx={{
          position: "relative",
          height: 8,
          borderRadius: 999,
          bgcolor: "action.hover",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            height: "100%",
            width: `${Math.min(100, Math.max(0, progress))}%`,
            borderRadius: 999,
            bgcolor: fillColor,
            transition: "width 0.3s ease, background-color 0.3s ease",
          }}
        />
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0.5 }}>
        {marks.map((mark) => (
          <Typography
            key={mark}
            variant="caption"
            color="text.secondary"
            sx={{ fontSize: "0.65rem" }}
          >
            {mark}%
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default StatusProgressBar;
